import _ from "lodash";
import LZString from "lz-string";
import Worker from "worker-loader?inline!./ll.worker";
import * as z from "../../framework";
import { alert } from "./alert";
import { requireArgument } from "./core";
import { bind } from "./kendo";
import { settings } from "./settings";

export const LocalizedLanguage: { [key: string]: string; } = {};

export function ll(str, noMessage?, showAlert?) {
    if (!str) {
        return null;
    }

    var result = noMessage ? "" : "Not Localized String",
    localizedString = LocalizedLanguage[str];

    if (str.indexOf(".") != -1 && !localizedString) {
        var lastIndex = str.lastIndexOf("."),
            newString = str.substr(lastIndex + 1);

        localizedString = LocalizedLanguage[newString];
    }

    if (localizedString) {
        result = localizedString;
    } else if (!noMessage && showAlert != false) {
        llMissing(str);
    }

    return result;
}

const showLLPrecedenceWarnings = false;

/**
 * Localizes a string by searching the provided array for an entry in localized language
 * @param {object} args
 * @param {string} args.precedence An array of localized language keys to try
 * @param {string} args.defaultString The string to return if no localized language is found
 * @param {object} [args.localizedLanguage] Object containing localized language keys and values
 * @param {boolean} [args.showLocalizationWarnings] Whether or not to show warnings when localization fails
 * @returns {string[]} The first value found in localized language, or the defaultString if none is found
 */
export function llPrecedence(args) {
    args = args || {};

    var precedence: string[] = requireArgument(args, "precedence");
    var defaultString: string = requireArgument(args, "defaultString");
    var localizedLanguage: { [key: string]: string } = args.localizedLanguage || LocalizedLanguage;
    var showLocalizationWarnings = args.showLocalizationWarnings !== undefined ? args.showLocalizationWarnings : showLLPrecedenceWarnings;

    var key = _.find(precedence, function (s) { return !!localizedLanguage[s]; });

    if (key) {
        return localizedLanguage[key];
    }

    if (showLocalizationWarnings) {
        llMissing(defaultString);
    }

    return defaultString;
}

export function llMissing(str) {
    console.warn("Add a localized language entry for the string: " + str);
    if (settings.showDebugMessages) {
        alert({
            type: "info",
            header: "Localized Language Missing",
            message: "Add a localized language entry for the string: " + str,
            wait: 10000
        });
    }
}

export function pseudoll(value) {
    var lower = "áβçδèƒϱλïJƙℓ₥ñôƥ9řƨƭúƲωж¥ƺ";
    var upper = "ÂßÇÐÉFGHÌJK£MNÓÞQR§TÛVWXÝZ";

    var newValue = "";
    for (var i = 0; i < value.length; i++) {
        var code = value.charCodeAt(i);
        if (code >= 65 && code <= 90) {
            newValue += upper[code - 65];
        } else if (code >= 97 && code <= 122) {
            newValue += lower[code - 97];
        } else {
            newValue += value[i];
        }
    }
    return newValue;
}

export function extendll(data) {
    if ($.isArray(data) || data instanceof kendo.data.ObservableArray) {
        if (localStorage.pseudoll == "true") {
            $.each(data, function (index, kvp) {
                LocalizedLanguage[kvp.Key] = pseudoll(kvp.Value);
            });
        } else {
            $.each(data, function (index, kvp) {
                LocalizedLanguage[kvp.Key] = kvp.Value;
            });
        }
    } else {
        if (localStorage.pseudoll == "true") {
            $.each(data, function (key, value) {
                LocalizedLanguage[key] = pseudoll(value);
            });
        } else {
            $.extend(LocalizedLanguage, data);
        }
    }
}

export function loadJSONLocale(locale) {
    var deferred = $.Deferred();

    $.ajax({
        url: `${__webpack_public_path__}Content/app/locale/${locale}.json`,
        // force to handle it as text
        dataType: "text",
        success: function (data) {
            // Initializes the worker.
            var worker = new Worker();

            // Adds an event listener which listens for a message from the worker.
            worker.addEventListener("message", (message) => {
                extendll(message.data.result);
                if (message.data.missingKeys && window.z.debuggerAttached) {
                    z.controls.alert({
                        header: "Missing Localized Language",
                        type: "info",
                        message: "See the console log.",
                        fade: false
                    });
                    console.log("Missing Keys", message.data.missingKeys);
                }
                deferred.resolve();
            });

            if (locale == "en-us") {
                // Sends a message to the worker containing the ll data to be parsed.
                worker.postMessage({
                    defaultLocale: data
                });
            } else {
                $.ajax({
                    url: `${__webpack_public_path__}Content/app/locale/en-us.json`,
                    // force to handle it as text
                    dataType: "text",
                    success: function (defaultData) {
                        // Sends a message to the worker containing the ll data to be parsed.
                        worker.postMessage({
                            locale: data,
                            defaultLocale: defaultData
                        });
                    },
                    error: function (error) {
                        console.log(error);
                    }
                });
            }
        },
        error: function (error) {
            console.log(error);
        }
    });

    return deferred;
}

export function bindLocalizedLanguage(bindObject) {
    bindObject.data = bindObject.data || LocalizedLanguage;
    bindObject.bind = bindObject.bind || ".bind-label";
    bind(bindObject);

    var elements = $(bindObject.container).find(bindObject.bind);
    $.each(elements, function (index, element) {
        var elementBind = $(element).data("bind");
        if (elementBind && elementBind.indexOf("text:") == 0) {
            elementBind = elementBind.substr(5).trim();
            ll(elementBind);
        }
    });
}
